var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screensaver",class:{ hidden: _vm.hidden }},[_c('div',{ref:"backElement",staticClass:"screensaver-item back"},[_c('img')]),_c('div',{ref:"frontElement",staticClass:"screensaver-item front"},[_c('img')])])}
var staticRenderFns = []

export { render, staticRenderFns }